const privacyPolicyNp = {
  breadcrumbs: { home: 'होम', title: 'गोपनीयता नीति' },
  hero: {
    title: 'हाम्रो गोपनीयता नीति',
    subtitle: 'हामी तपाईंका डाटा सुरक्षित राख्छौं र पारदर्शिताका साथ प्रयोग गर्छौं'
  },
  principles: [
    { title: 'सुरक्षा', description: 'हामी तपाईंको डाटाको सुरक्षा सुनिश्चित गर्न उद्योग-स्तरीय प्रविधि प्रयोग गर्छौं।' },
    { title: 'पारदर्शिता', description: 'हामी कसरी डाटा संकलन, प्रयोग, र साझेदारी हुन्छ स्पष्ट रूपमा बताउँछौं।' },
    { title: 'नियन्त्रण', description: 'तपाईंलाई आफ्नो डाटामा पहुँच, परिवर्तन, र मेटाउने अधिकार छ।' },
    { title: 'जिम्मेवारी', description: 'हामी कानुनी र नैतिक मान्यताअनुसार डाटा संभाल्छौं।' }
  ],
  dataTypes: [
    { category: 'व्यक्तिगत विवरण', items: ['नाम', 'इमेल', 'फोन'], purpose: 'खाता र सेवासम्बन्धी सम्पर्कका लागि' },
    { category: 'स्थानसम्बन्धी जानकारी', items: ['जिल्ला', 'उपजिल्ला', 'बजार'], purpose: 'स्थानअनुसार सेवा र डेलिभरी सुधार्न' },
    { category: 'भुक्तानी विवरण', items: ['भुक्तानी विधि', 'कार्ड/मोबाइल विवरण (आवश्यक परे मात्र)'], purpose: 'भुक्तानी प्रक्रिया गर्न' },
    { category: 'डिभाइस/प्रयोग डाटा', items: ['ब्राउजर', 'डिभाइस', 'प्रयोग ढाँचा'], purpose: 'साइटको प्रदर्शन र अनुभव सुधार्न' }
  ],
  usage: {
    title: 'हामी तपाईंको डाटा कसरी प्रयोग गर्छौं',
    primaryTitle: 'मुख्य प्रयोग',
    primary: [
      'खाता सिर्जना, लगिन र सत्यापन',
      'अर्डर प्रोसेस र डेलिभरी',
      'ग्राहकसम्पर्क र सहयोग',
      'कानुनी पालना'
    ],
    improveTitle: 'सेवा सुधार',
    improve: [
      'साइट अनुभव सुधार',
      'नयाँ फीचर विकास',
      'दुरुपयोग/फ्रड पहिचान',
      'विश्लेषण र रिपोर्टिङ'
    ]
  },
  rights: {
    title: 'तपाईंका अधिकारहरू',
    items: [
      { right: 'डेटा पहुँच', description: 'तपाईंले आफ्नो डाटा हेर्न र प्रतिलिपि पाउन सक्नुहुन्छ।' },
      { right: 'संशोधन', description: 'गलत डाटा सच्याउन अनुरोध गर्न सक्नुहुन्छ।' },
      { right: 'मेटाउने', description: 'कानुन अनुसार सम्भव हुँदा डाटा मेटाउन अनुरोध गर्न सक्नुहुन्छ।' },
      { right: 'डाउनलोड', description: 'तपाईंको डाटा पोर्टेबल ढाँचामा डाउनलोड गर्न सक्नुहुन्छ।' }
    ]
  },
  security: {
    title: 'सुरक्षा उपायहरू',
    intro: 'हामी बहु-स्तरीय सुरक्षा, इन्क्रिप्सन, र एक्सेस नियन्त्रण अपनाउँछौं।',
    measures: [
      'HTTPS/SSL इन्क्रिप्सन',
      'नियमित सुरक्षा अडिट',
      'रोल-आधारित एक्सेस नियन्त्रण',
      'डेटा ब्याकअप र रिकभरी',
      'थर्ड-पार्टी सुरक्षा परीक्षण',
      'अनधिकृत पहुँचको निगरानी'
    ]
  },
  cookies: {
    title: 'कुकीज नीति',
    usageTitle: 'हामी कुकीज कसरी प्रयोग गर्छौं',
    p1: 'कुकीजले तपाईंको लगइन, भाषा प्राथमिकता, र कार्ट जस्ता सुविधाहरू स्मरण गराउन मद्दत गर्छ।',
    p2: 'तपाईं ब्राउजर सेटिङबाट कुकीज नियन्त्रण गर्न सक्नुहुन्छ। तर केही सुविधा निष्क्रिय हुन सक्छन्।'
  },
  sharing: {
    title: 'तृतीय पक्षसँग साझेदारी',
    intro: 'हामी केवल आवश्यक परेमा विश्वसनीय भागीदारसँग न्यूनतम डाटा साझेदारी गर्छौं।',
    authorizedTitle: 'हामीले जहाँ साझेदारी गर्न सक्छौं',
    authorized: ['डेलिभरी प्रदायक', 'भुक्तानी सेवा प्रदायक', 'कानुनी आवश्यकताअनुसार निकाय'],
    notDoTitle: 'हामीले गर्ने छैनौं',
    notDo: ['तपाईंको डाटा खुला बेच्ने', 'अनुमति बिना मार्केटिङ', 'असुरक्षित माध्यमबाट साझेदारी']
  },
  retention: {
    title: 'डाटा संरक्षण अवधि',
    retentionTitle: 'हामी डाटा कति समय राख्छौं',
    retentionText: 'कानुनी र व्यवसायिक आवश्यकताअनुसार आवश्यक समयसम्म मात्र डाटा राखिन्छ।',
    deleteTitle: 'मेटाउने नीति',
    deleteText: 'अनुरोध वा कानुनी आवश्यकता परेमा, सुरक्षित रूपमा डाटा स्थायी रूपमा मेटाइन्छ।'
  },
  updates: {
    title: 'नीति अद्यावधिक',
    alert: 'यो नीति समयअनुसार अद्यावधिक हुन सक्छ।',
    notify: 'महत्वपूर्ण परिवर्तनको सूचना साइट वा इमेलमार्फत दिइनेछ।',
    lastUpdatedPrefix: 'अन्तिम अद्यावधिक:',
    lastUpdatedDate: 'सेप्टेम्बर २०२4'
  },
  contact: {
    title: 'गोपनीयतासम्बन्धी प्रश्नहरू?',
    subtitle: 'कुनै जिज्ञासा वा अनुरोध भए हामीलाई सम्पर्क गर्नुहोस्।',
    button: 'सम्पर्क पृष्ठमा जानुहोस्',
    email: 'privacy@grameenbazar.com मा इमेल गर्नुहोस्'
  }
};

export default privacyPolicyNp;


